[
  {
    "brand": "Hager",
    "range": "MW (2P 3 kA, MWN screw / MWS QuickConnect)",
    "reference": "MWN210A",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 10,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Automaat 3kA C 2P 10A 2M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mwn210a-automaat-2p-3ka-c-10a-2m"
  },
  {
    "brand": "Hager",
    "range": "MW (2P 3 kA, MWN screw / MWS QuickConnect)",
    "reference": "MWN216A",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Automaat 3kA C 2P 16A 2M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mwn216a-automaat-2p-3ka-c-16a-2m"
  },
  {
    "brand": "Hager",
    "range": "MW (2P 3 kA, MWN screw / MWS QuickConnect)",
    "reference": "MWN220A",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Automaat 3kA C 2P 20A 2M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mwn220a-automaat-2p-3ka-c-20a-2m"
  },
  {
    "brand": "Hager",
    "range": "MW (2P 3 kA, MWN screw / MWS QuickConnect)",
    "reference": "MWS225A",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 25,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Automaat 3kA C 2P 25A 2M quickconnect",
    "sourceUrl": "https://assets.hager.com/step-content/P/PDS_157728181401NL/Document/std.lang.all/MWS225A_1401_nl-BE.pdf"
  },
  {
    "brand": "Hager",
    "range": "MW (2P 3 kA, MWN screw / MWS QuickConnect)",
    "reference": "MWS232A",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 32,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Automaat 3kA C 2P 32A 2M quickconnect",
    "sourceUrl": "https://groothandel.be/p/hager-automaat-3ka-c-2p-32a-2m-qc-mws232a/"
  },
  {
    "brand": "Hager",
    "range": "MW (2P 3 kA, MWN screw / MWS QuickConnect)",
    "reference": "MWS240A",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 40,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Automaat 3kA C 2P 40A 2M quickconnect",
    "sourceUrl": "https://groothandel.be/p/hager-automaat-3ka-c-2p-40a-2m-qc-mws240a/"
  },
  {
    "brand": "Hager",
    "range": "MC (6 kA)",
    "reference": "MCA216",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 2,
    "description": "Automaat 6kA C 2P 16A 2M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mca216-automaat-6ka-c-2p-16a-2m"
  },
  {
    "brand": "Hager",
    "range": "MC (6 kA)",
    "reference": "MCA220",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 2,
    "description": "Automaat 6kA C 2P 20A 2M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mca220-automaat-6ka-c-2p-20a-2m"
  },
  {
    "brand": "Hager",
    "range": "MC (6 kA)",
    "reference": "MCA225",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 25,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 2,
    "description": "Automaat 6kA C 2P 25A 2M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mca225-autom-6ka-c-2p-25a-2m"
  },
  {
    "brand": "Hager",
    "range": "MC (6 kA)",
    "reference": "MCA416",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 4,
    "description": "Automaat 6kA C 4P 16A 4M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mca416-automaat-6ka-c-4p-16a-4m"
  },
  {
    "brand": "Hager",
    "range": "MC (6 kA)",
    "reference": "MCA420",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 4,
    "description": "Automaat 6kA C 4P 20A 4M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mca420-automaat-6ka-c-4p-20a-4m"
  },
  {
    "brand": "Hager",
    "range": "MC (6 kA)",
    "reference": "MCA432",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 32,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 4,
    "description": "Automaat 6kA C 4P 32A 4M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mca432-automaat-6ka-c-4p-32a-4m"
  },
  {
    "brand": "Hager",
    "range": "MC (6 kA)",
    "reference": "MCA440",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 40,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 4,
    "description": "Automaat 6kA C 4P 40A 4M",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/mca440-autom-6ka-c-4p-40a-4m"
  },
  {
    "brand": "Hager",
    "range": "Aardlekschakelaars C (CEBEC)",
    "reference": "CDA263E",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "Aardlekschakelaar 2P 63A 30mA klasse A CEBEC",
    "sourceUrl": "https://assets.hager.com/step-content/P/PDS_158672511401NL/Document/std.lang.all/CDA263E_1401_nl-BE.pdf"
  },
  {
    "brand": "Hager",
    "range": "Aardlekschakelaars C (CEBEC)",
    "reference": "CFA240E",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "Aardlekschakelaar 2P 40A 300mA klasse A CEBEC",
    "sourceUrl": "https://hager.com/nl-be/catalogus/catalog/product/download/id/CFA240E"
  },
  {
    "brand": "Hager",
    "range": "Aardlekschakelaars C (CEBEC)",
    "reference": "CPA263E",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "Aardlekschakelaar 2P 63A 300mA A selectief (S)",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/cpa263e-aardlekschakelaar-2p-63a-300ma-a-s"
  },
  {
    "brand": "Hager",
    "range": "Aardlekschakelaars C (CEBEC)",
    "reference": "CDA440E",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 4,
    "description": "Aardlekschakelaar 4P 40A 30mA klasse A CEBEC",
    "sourceUrl": "https://assets.hager.com/step-content/P/PDS_157722681401NL/Document/std.lang.all/CDA440E_1401_nl-BE.pdf"
  },
  {
    "brand": "Hager",
    "range": "Aardlekschakelaars C (CEBEC)",
    "reference": "CFA440E",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 4,
    "description": "Aardlekschakelaar 4P 40A 300mA klasse A CEBEC",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/cfa440e-aardlekschakelaar-4p-40a-300ma-a"
  },
  {
    "brand": "Hager",
    "range": "Aardlekschakelaars C (CEBEC)",
    "reference": "CDB540E",
    "kind": "rcd",
    "poles": "1P+N",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "B",
    "breakingKa": null,
    "modules": 4,
    "description": "Aardlekschakelaar 1P+N 40A 30mA klasse B",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/cdb540e-aardlekschakelaar-1p-n-40a-30ma-kl-b"
  },
  {
    "brand": "Hager",
    "range": "SBN lastscheiders",
    "reference": "SBN240",
    "kind": "switch-disconnector",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "Modulaire lastscheider 2P 40A grijze tuimel",
    "sourceUrl": "https://assets.hager.com/step-content/P/PDS_774769281401NL/Document/std.lang.all/PDS_SBN240_1401_nl-BE.pdf"
  },
  {
    "brand": "Hager",
    "range": "SBN lastscheiders",
    "reference": "SBN263",
    "kind": "switch-disconnector",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "Modulaire lastscheider 2P 63A grijze tuimel",
    "sourceUrl": "https://assets.hager.com/step-content/P/PDS_774769341401NL/Document/std.lang.all/PDS_SBN263_1401_nl-BE.pdf"
  },
  {
    "brand": "Hager",
    "range": "SBN lastscheiders",
    "reference": "SBN440",
    "kind": "switch-disconnector",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 4,
    "description": "Modulaire lastscheider 4P 40A grijze tuimel",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/sbn440-lastscheider-4-polig-40-a-grijze-tuimel"
  },
  {
    "brand": "Hager",
    "range": "SBN lastscheiders",
    "reference": "SBN463",
    "kind": "switch-disconnector",
    "poles": "4P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 4,
    "description": "Modulaire lastscheider 4P 63A grijze tuimel",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/sbn463-lastscheider-4-polig-63-a-grijze-tuimel"
  },
  {
    "brand": "Hager",
    "range": "ESC contactors",
    "reference": "ESC225",
    "kind": "contactor",
    "poles": "2P",
    "ratingA": 25,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 1,
    "description": "Magneetschakelaar 25A 2NO 230V",
    "sourceUrl": "https://hager.com/nl-be/catalogus/producten/esc225-magneetsch-25a-2m-230v"
  },
  {
    "brand": "Hager",
    "range": "EPN impulse relays",
    "reference": "EPN510",
    "kind": "impulse-relay",
    "poles": "1P",
    "ratingA": 16,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 1,
    "description": "Teleruptor 16A 1NO 230V",
    "sourceUrl": "https://hager.com/fr-be/catalogue/produits/epn510-telerupteur-1f-230v"
  },
  {
    "brand": "Hager",
    "range": "SP overspanningsbeveiliging",
    "reference": "SPB215D",
    "kind": "spd",
    "poles": "1P+N",
    "ratingA": null,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "Overspanningsbeveiliging T2, TT/TN-S, Imax 15kA, In 5kA, Up 1kV",
    "sourceUrl": "https://assets.hager.com/step-content/P/PDS_397595551401NL/Document/std.lang.all/SPB215D_1401_nl-BE.pdf"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64210",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 10,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Resi9 modulaire automaat 2P 10A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64210/resi9-modulaire-automaat-2p-10a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64216",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Resi9 modulaire automaat 2P 16A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64216/resi9-modulaire-automaat-2p-16a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64220",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Resi9 modulaire automaat 2P 20A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64220/resi9-modulaire-automaat-2p-20a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64225",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 25,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Resi9 modulaire automaat 2P 25A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64225/resi9-modulaire-automaat-2p-25a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64232",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 32,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Resi9 modulaire automaat 2P 32A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64232/resi9-modulaire-automaat-2p-32a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64240",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 40,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Resi9 modulaire automaat 2P 40A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64240/resi9-modulaire-automaat-2p-40a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64416",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 4,
    "description": "Resi9 modulaire automaat 4P 16A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64416/resi9-modulaire-automaat-4p-16a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64420",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 4,
    "description": "Resi9 modulaire automaat 4P 20A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64420/resi9-modulaire-automaat-4p-20a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64432",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 32,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 4,
    "description": "Resi9 modulaire automaat 4P 32A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64432/resi9-modulaire-automaat-4p-32a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9F64440",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 40,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 4,
    "description": "Resi9 modulaire automaat 4P 40A curve C 3000A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9F64440/resi9-modulaire-automaat-4p-40a-400v-curve-c-kortsluitvermogen3000a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9R01240",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": null,
    "description": "Resi9 differentieelschakelaar 2P 40A 30mA ogenblikkelijk type A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9R01240/resi9-differentieelschakelaar-2p-40a-gevoeligheid30-ma-ogenblikkelijk-type-a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9R04240",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": null,
    "description": "Resi9 differentieelschakelaar 2P 40A 300mA ogenblikkelijk type A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9R04240/resi9-differentieelschakelaar-2p-40a-gevoeligheid300-ma-ogenblikkelijk-type-a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9R01263",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": null,
    "description": "Resi9 differentieelschakelaar 2P 63A 30mA ogenblikkelijk type A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9R01263/resi9-differentieelschakelaar-2p-63a-gevoeligheid30-ma-ogenblikkelijk-type-a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9R04263",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": null,
    "description": "Resi9 differentieelschakelaar 2P 63A 300mA ogenblikkelijk type A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9R04263/resi9-differentieelschakelaar-2p-63a-gevoeligheid300-ma-ogenblikkelijk-type-a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9R01440",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": null,
    "description": "Resi9 differentieelschakelaar 4P 40A 30mA ogenblikkelijk type A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9R01440/resi9-differentieelschakelaar-4p-40a-gevoeligheid30-ma-ogenblikkelijk-type-a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Resi9",
    "reference": "R9R04440",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": null,
    "description": "Resi9 differentieelschakelaar 4P 40A 300mA ogenblikkelijk type A",
    "sourceUrl": "https://www.se.com/be/nl/product/R9R04440/resi9-differentieelschakelaar-4p-40a-gevoeligheid300-ma-ogenblikkelijk-type-a/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iID",
    "reference": "A9Z61240",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "B",
    "breakingKa": null,
    "modules": 4,
    "description": "Acti9 iID aardlekschakelaar 2P 40A 30mA type B-SI",
    "sourceUrl": "https://www.one-elec.com/nl/a9z61240-acti9-iid-aardlekschakelaar-2p-40a-30ma-type-b-si-a9z61240-schneider.html"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iID",
    "reference": "A9Z61440",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "B",
    "breakingKa": null,
    "modules": 4,
    "description": "Acti9 iID differentieelschakelaar 4P 40A 30mA type B-SI",
    "sourceUrl": "https://groothandel.be/p/schneider-distribution-acti9-iid-differentieelschakelaar-4p-40a-30ma-b-si-type-a9z61440/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iDPN H Vigi",
    "reference": "A9D37616",
    "kind": "rcbo",
    "poles": "1P+N",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": 10,
    "modules": 2,
    "description": "Differentieelautomaat iDPN H Vigi 1P+N C16 30mA type A",
    "sourceUrl": "https://groothandel.be/p/schneider-distribution-differentieel-automaat-idpn-h-vigi-1pn-c16-30ma-type-a-a9d37616/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iDPN H Vigi",
    "reference": "A9D37620",
    "kind": "rcbo",
    "poles": "1P+N",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": 10,
    "modules": 2,
    "description": "RCBO iDPN H Vigi 1P+N C20 30mA type A 10kA",
    "sourceUrl": "https://prof-elec.com/all-categories/circuit-protection/modular-circuit-breakers/a9d37620-en/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iSW",
    "reference": "A9S65240",
    "kind": "switch-disconnector",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "Lastschakelaar iSW 2P 40A",
    "sourceUrl": "https://www.cebeo.be/catalog/nl-be/products/schneider-distribution-lastschakelaar-isw-2p-40-a-240-v-4568253"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iSW",
    "reference": "A9S65263",
    "kind": "switch-disconnector",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "iSW lastscheider 2P 63A 415V AC",
    "sourceUrl": "https://www.one-elec.com/nl/isw-lastscheider-2p-in-63a-ue-415v-ac-a9s65263.html"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iSW",
    "reference": "A9S65440",
    "kind": "switch-disconnector",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 4,
    "description": "iSW lastscheider 4P 40A 415V AC",
    "sourceUrl": "https://www.one-elec.com/nl/iil-lastschakelaar-4p-in-40a-415v-ac-a9s65440.html"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iSW",
    "reference": "A9S65463",
    "kind": "switch-disconnector",
    "poles": "4P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 4,
    "description": "iSW lastscheider 4P 63A 415V AC",
    "sourceUrl": "https://www.one-elec.com/nl/isw-lastscheider-4p-in-63a-ue-415v-ac-a9s65463.html"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iCT",
    "reference": "A9C20732",
    "kind": "contactor",
    "poles": "2P",
    "ratingA": 25,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 1,
    "description": "iCT contactor 25A 2NO 230-240V 50Hz",
    "sourceUrl": "https://www.se.com/be/nl/product/A9C20732/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iTL",
    "reference": "A9C30811",
    "kind": "impulse-relay",
    "poles": "1P",
    "ratingA": 16,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 1,
    "description": "Teleruptor iTL 1P 1NO 16A spoel 230-240V AC / 110V DC",
    "sourceUrl": "https://www.se.com/be/nl/product/A9C30811/"
  },
  {
    "brand": "Schneider Electric",
    "range": "Acti9 iPRD",
    "reference": "A9L40501",
    "kind": "spd",
    "poles": "1P+N",
    "ratingA": null,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "iPRD40r overspanningsbeveiliging T2 1P+N In 15kA Imax 40kA, met signalisatie",
    "sourceUrl": "https://www.se.com/be/nl/product/A9L40501/"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0104",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 10,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 C10 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0164",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 C16 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0204",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 C20 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0254",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 25,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 C25 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0324",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 32,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 C32 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0404",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 40,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 C40 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0105",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 10,
    "curve": "B",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 B10 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0165",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 16,
    "curve": "B",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 B16 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0205",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 20,
    "curve": "B",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 B20 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0255",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 25,
    "curve": "B",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 B25 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0325",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 32,
    "curve": "B",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 B32 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SN201 (1P+N, 1 module, 6 kA)",
    "reference": "2CSS255101R0405",
    "kind": "breaker",
    "poles": "1P+N",
    "ratingA": 40,
    "curve": "B",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 1,
    "description": "SN201 B40 automaat 1P+N 6kA",
    "sourceUrl": "https://library.e.abb.com/public/c74cd1a29fc8a22ec12574fd0035a4ac/2CSC402001B0901.pdf"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact S200",
    "reference": "2CDS254001R0164",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 4,
    "description": "S204-C16 automaat 4P",
    "sourceUrl": "https://www.one-elec.com/en/miniature-circuit-breaker-abb-s204-c16-4p-16a-curve-c-6ka-abb2cds254001r0164.html"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact S200",
    "reference": "2CDS254001R0204",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 4,
    "description": "S204-C20 automaat 4P",
    "sourceUrl": "https://groupsumi.pt/en/electricity/electrical-protection-and-control/magnetothermal/s204-c20-4p-20a-curve-c-10ka-circuit-breaker-2cds254001r0204"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact S200",
    "reference": "2CDS254001R0324",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 32,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 4,
    "description": "S204-C32 automaat 4P",
    "sourceUrl": "https://ie.rs-online.com/web/p/mcbs/7467817"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact S200",
    "reference": "2CDS254001R0404",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 40,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 4,
    "description": "S204-C40 automaat 4P",
    "sourceUrl": "https://twcn.rs-online.com/web/p/mcbs/1833646"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact F200",
    "reference": "2CSF202101R1400",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "F202 A-40/0,03",
    "sourceUrl": "https://plc-direct.com/products/2csf202101r1400"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact F200",
    "reference": "2CSF202101R3400",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "F202 A-40/0,3",
    "sourceUrl": "https://www.electricautomationnetwork.com/en/abb/f202-a-40-03-residual-current-dev-abb-f202a-40-03-2csf202101r3400"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact F200",
    "reference": "2CSF202101R1630",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "F202 A-63/0,03",
    "sourceUrl": "https://www.electricautomationnetwork.com/en/abb/f202-a-63-003-residual-current-dev-abb-f202a-63-003-2csf202101r1630"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact F200",
    "reference": "2CSF202101R3630",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "F202 A-63/0,3",
    "sourceUrl": "https://www.electricautomationnetwork.com/en/abb/f202-a-63-03-residual-current-dev-abb-f202a-63-03-2csf202101r3630"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact F200",
    "reference": "2CSF204101R1400",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 4,
    "description": "F204 A-40/0,03",
    "sourceUrl": "https://www.electricautomationnetwork.com/en/abb/f204-a-40-003-residual-current-dev-abb-f204a-40-003-2csf204101r1400"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact F200",
    "reference": "2CSF204101R3400",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 4,
    "description": "F204 A-40/0,3",
    "sourceUrl": "https://www.electricautomationnetwork.com/en/abb/f204-a-40-03-residual-current-dev-abb-f204a-40-03-2csf204101r3400"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact F200",
    "reference": "2CSF202592R1400",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "B",
    "breakingKa": null,
    "modules": 2,
    "description": "F202 B-40/0,03",
    "sourceUrl": "https://www.electricautomationnetwork.com/en/abb/f202-b-40-003-residual-current-dev-abb-f202b-40-003-2csf202592r1400"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact DS201",
    "reference": "2CSR255140R1164",
    "kind": "rcbo",
    "poles": "1P+N",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": 6,
    "modules": 2,
    "description": "DS201 C16 A30",
    "sourceUrl": "https://shop.lakelandengineering.com/products/2CSR255140R1164"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact DS201",
    "reference": "2CSR255140R1204",
    "kind": "rcbo",
    "poles": "1P+N",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": 6,
    "modules": 2,
    "description": "DS201 C20 A30",
    "sourceUrl": "https://www.electricautomationnetwork.com/en/abb/ds201-c20-a30-rcbo-abb-ds201c20a30-2csr255140r1204"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SD200",
    "reference": "2CDD282101R0040",
    "kind": "switch-disconnector",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "SD202/40",
    "sourceUrl": "https://fr.rs-online.com/web/p/interrupteurs-d-isolement/1755086"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SD200",
    "reference": "2CDD282101R0063",
    "kind": "switch-disconnector",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "SD202/63",
    "sourceUrl": "https://pt.rs-online.com/web/p/interruptores-seccionadores/1863493"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SD200",
    "reference": "2CDD284101R0040",
    "kind": "switch-disconnector",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 4,
    "description": "SD204/40",
    "sourceUrl": "https://befr.rs-online.com/web/p/isolator-switches/1755099"
  },
  {
    "brand": "ABB",
    "range": "System pro M compact SD200",
    "reference": "2CDD284101R0063",
    "kind": "switch-disconnector",
    "poles": "4P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 4,
    "description": "SD204/63",
    "sourceUrl": "https://www.voltimum.co.uk/product-details/4VNcnQ9q/abb/switch-disconnector"
  },
  {
    "brand": "ABB",
    "range": "ESB installation contactors",
    "reference": "1SAE231111R0620",
    "kind": "contactor",
    "poles": "2P",
    "ratingA": 25,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "ESB25-20N-06 installatiecontactor 2NO 230V",
    "sourceUrl": "https://uk.rs-online.com/web/p/contactors/2111464"
  },
  {
    "brand": "ABB",
    "range": "E290 impulse relays",
    "reference": "2TAZ312000R2011",
    "kind": "impulse-relay",
    "poles": "1P",
    "ratingA": 16,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 1,
    "description": "E290-16-10/230 impulsschakelaar 1NO 230V AC",
    "sourceUrl": "https://www.cebeo.be/catalog/nl-be/products/abb-impulsschakelaar-e290-16a-1no-230v-ac-110v-dc-din-rail-grijs-5474596"
  },
  {
    "brand": "ABB",
    "range": "OVR",
    "reference": "2CTB803952R1100",
    "kind": "spd",
    "poles": "1P+N",
    "ratingA": null,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "OVR T2 1N 40-275 P, Uc 275V, In 20kA, Imax 40kA, Up 1.4kV",
    "sourceUrl": "https://www.kvc.com.my/Products/Circuit-and-Load-Protection/Surge-Protectors/OVR-T2-1N-40-275-P-SPD-40KA-1PN-zid2161919"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403115",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 10,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Aut. TX³ 3000A 2P C10 230/400V 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403116",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Aut. TX³ 3000A 2P C16 230/400V 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403117",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Aut. TX³ 3000A 2P C20 230/400V 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403118",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 25,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Aut. TX³ 3000A 2P C25 230/400V 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403119",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 32,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Aut. TX³ 3000A 2P C32 230/400V 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403120",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 40,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 2,
    "description": "Aut. TX³ 3000A 2P C40 230/400V 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 6000",
    "reference": "403387",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 16,
    "curve": "B",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 2,
    "description": "Aut. TX³ 6000 2P B16 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p181.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 6000",
    "reference": "403388",
    "kind": "breaker",
    "poles": "2P",
    "ratingA": 20,
    "curve": "B",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 6,
    "modules": 2,
    "description": "Aut. TX³ 6000 2P B20 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p181.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403136",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 4,
    "description": "Aut. TX³ 3000A 4P C16 400V 4 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403137",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 4,
    "description": "Aut. TX³ 3000A 4P C20 400V 4 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403139",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 32,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 4,
    "description": "Aut. TX³ 3000A 4P C32 400V 4 modules",
    "sourceUrl": "https://legrand.be/nl/catalogus/aut-tx3-3000a-4p-c32-400v-4-modules-403139"
  },
  {
    "brand": "Legrand",
    "range": "TX³ 3000 (residentieel)",
    "reference": "403140",
    "kind": "breaker",
    "poles": "4P",
    "ratingA": 40,
    "curve": "C",
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": 3,
    "modules": 4,
    "description": "Aut. TX³ 3000A 4P C40 400V 4 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p180.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ differentieelschakelaars",
    "reference": "411912",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "Differentieelschakelaar TX³ 2P 40A 30mA type A",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p182.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ differentieelschakelaars",
    "reference": "411913",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "Differentieelschakelaar TX³ 2P 63A 30mA type A",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p182.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ differentieelschakelaars",
    "reference": "411922",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "Differentieelschakelaar TX³ 2P 40A 300mA type A",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p182.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ differentieelschakelaars",
    "reference": "411923",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 2,
    "description": "Differentieelschakelaar TX³ 2P 63A 300mA type A",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p182.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ differentieelschakelaars",
    "reference": "411932",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 4,
    "description": "Differentieelschakelaar TX³ 4P 40A 30mA type A",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p182.pdf"
  },
  {
    "brand": "Legrand",
    "range": "TX³ differentieelschakelaars",
    "reference": "411942",
    "kind": "rcd",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 300,
    "rcdType": "A",
    "breakingKa": null,
    "modules": 4,
    "description": "Differentieelschakelaar TX³ 4P 40A 300mA type A",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p182.pdf"
  },
  {
    "brand": "Legrand",
    "range": "DX³-ID",
    "reference": "411956",
    "kind": "rcd",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": 30,
    "rcdType": "B",
    "breakingKa": null,
    "modules": 4,
    "description": "Differentieelschakelaar DX³-ID 2P 40A 30mA type B",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p196.pdf"
  },
  {
    "brand": "Legrand",
    "range": "DX³ 6000 differentieelautomaten",
    "reference": "411061",
    "kind": "rcbo",
    "poles": "1P+N",
    "ratingA": 16,
    "curve": "C",
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": 6,
    "modules": 2,
    "description": "Differentieelautomaat DX³ 6000 1P+N C16 30mA type A 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p197.pdf"
  },
  {
    "brand": "Legrand",
    "range": "DX³ 6000 differentieelautomaten",
    "reference": "411062",
    "kind": "rcbo",
    "poles": "1P+N",
    "ratingA": 20,
    "curve": "C",
    "sensitivityMa": 30,
    "rcdType": "A",
    "breakingKa": 6,
    "modules": 2,
    "description": "Differentieelautomaat DX³ 6000 1P+N C20 30mA type A 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p197.pdf"
  },
  {
    "brand": "Legrand",
    "range": "Lastscheidingsschakelaars (DX³-IS)",
    "reference": "406440",
    "kind": "switch-disconnector",
    "poles": "2P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "Lastscheidingsschakelaar 2P 40A 400V",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p206.pdf"
  },
  {
    "brand": "Legrand",
    "range": "Lastscheidingsschakelaars (DX³-IS)",
    "reference": "406441",
    "kind": "switch-disconnector",
    "poles": "2P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "Lastscheidingsschakelaar 2P 63A 400V",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p206.pdf"
  },
  {
    "brand": "Legrand",
    "range": "Lastscheidingsschakelaars (DX³-IS)",
    "reference": "406480",
    "kind": "switch-disconnector",
    "poles": "4P",
    "ratingA": 40,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 4,
    "description": "Lastscheidingsschakelaar 4P 40A 400V",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p206.pdf"
  },
  {
    "brand": "Legrand",
    "range": "Lastscheidingsschakelaars (DX³-IS)",
    "reference": "406481",
    "kind": "switch-disconnector",
    "poles": "4P",
    "ratingA": 63,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 4,
    "description": "Lastscheidingsschakelaar 4P 63A 400V",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p206.pdf"
  },
  {
    "brand": "Legrand",
    "range": "CX³",
    "reference": "412544",
    "kind": "contactor",
    "poles": "2P",
    "ratingA": 25,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 1,
    "description": "Contactor CX³ 2P 25A 2NO spoel 230V, 1 module",
    "sourceUrl": "https://www.legrand.com/ecatalogue/412544-power-contactor-cx-with-230.html"
  },
  {
    "brand": "Legrand",
    "range": "CX³",
    "reference": "412420",
    "kind": "impulse-relay",
    "poles": "1P",
    "ratingA": 16,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 1,
    "description": "CX³ standaard teleruptor 1P 230V 16A NO 1 module",
    "sourceUrl": "https://www.legrand.nl/nl/catalogus/cx3-standaard-teleruptor-1p-230v-16a-no-automatische-klemmen-1-module-412420"
  },
  {
    "brand": "Legrand",
    "range": "Overspanningsbeveiligers",
    "reference": "412246",
    "kind": "spd",
    "poles": "1P+N",
    "ratingA": null,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 2,
    "description": "Overspanningsbeveiliger T2 1P+N 40kA Uc 320V 2 modules",
    "sourceUrl": "https://assets.legrand.com/pim/DOCUMENT/CB2022_2023NL_lr-p200.pdf"
  },
  {
    "brand": "Niko",
    "range": "Original White",
    "reference": "170-33100+101-66601+101-76100",
    "kind": "socket",
    "poles": "2P",
    "ratingA": 16,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": null,
    "description": "Stopcontact met penaarde en kinderveiligheid 16A, schroefklemmen (sokkel + centraalplaat + afdekplaat)",
    "sourceUrl": "https://www.elektramat.be/niko-sokkel-stopcontact-met-penaarde-16a-diepte-28-5mm-met-schroefklemmen-en-klauwen-170-33100/",
    "parts": [
      {
        "reference": "170-33100",
        "description": "Sokkel stopcontact met penaarde 16A, diepte 28,5 mm, schroefklemmen en klauwen",
        "sourceUrl": "https://www.elektramat.be/niko-sokkel-stopcontact-met-penaarde-16a-diepte-28-5mm-met-schroefklemmen-en-klauwen-170-33100/"
      },
      {
        "reference": "101-66601",
        "description": "Centraalplaat stopcontact met penaarde en kinderveiligheid, Original White",
        "sourceUrl": "https://www.elektramat.be/niko-centraalplaat-voor-stopcontact-met-penaarde-en-kinderveiligheid-inbouwdiepte-28-5mm-original-white-101-66601/"
      },
      {
        "reference": "101-76100",
        "description": "Enkelvoudige afdekplaat, Original White",
        "sourceUrl": "https://www.elektramat.be/niko-enkelvoudige-afdekplaat-original-white-101-76100/"
      }
    ]
  },
  {
    "brand": "Niko",
    "range": "Original White",
    "reference": "170-33105+101-66601+101-76100",
    "kind": "socket",
    "poles": "2P",
    "ratingA": 16,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": null,
    "description": "Stopcontact met penaarde en kinderveiligheid 16A, insteekklemmen (sokkel + centraalplaat + afdekplaat)",
    "sourceUrl": "https://www.elektramat.be/niko-sokkel-stopcontact-met-penaarde-16a-diepte-28-5mm-met-insteekklemmen-en-klauwen-170-33105",
    "parts": [
      {
        "reference": "170-33105",
        "description": "Sokkel stopcontact met penaarde 16A, diepte 28,5 mm, insteekklemmen en klauwen",
        "sourceUrl": "https://www.elektramat.be/niko-sokkel-stopcontact-met-penaarde-16a-diepte-28-5mm-met-insteekklemmen-en-klauwen-170-33105"
      },
      {
        "reference": "101-66601",
        "description": "Centraalplaat stopcontact met penaarde en kinderveiligheid, Original White",
        "sourceUrl": "https://www.elektramat.be/niko-centraalplaat-voor-stopcontact-met-penaarde-en-kinderveiligheid-inbouwdiepte-28-5mm-original-white-101-66601/"
      },
      {
        "reference": "101-76100",
        "description": "Enkelvoudige afdekplaat, Original White",
        "sourceUrl": "https://www.elektramat.be/niko-enkelvoudige-afdekplaat-original-white-101-76100/"
      }
    ]
  },
  {
    "brand": "Niko",
    "range": "Original White",
    "reference": "101-61108+101-76100",
    "kind": "switch",
    "poles": "1P",
    "ratingA": 10,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": null,
    "description": "Enkelpolige schakelaar 10AX, insteekklemmen, met afwerkingsset (sokkel + centraalplaat) en afdekplaat",
    "sourceUrl": "https://cdn.niko.eu/article/101-61108_nl-BE_datasheet.pdf",
    "parts": [
      {
        "reference": "101-61108",
        "description": "Enkelpolige schakelaar, sokkel, insteekklemmen en afwerkingsset, white",
        "sourceUrl": "https://cdn.niko.eu/article/101-61108_nl-BE_datasheet.pdf"
      },
      {
        "reference": "101-76100",
        "description": "Enkelvoudige afdekplaat, Original White",
        "sourceUrl": "https://www.elektramat.be/niko-enkelvoudige-afdekplaat-original-white-101-76100/"
      }
    ]
  },
  {
    "brand": "Niko",
    "range": "Home Control II",
    "reference": "550-00003",
    "kind": "home-automation",
    "poles": "2P",
    "ratingA": null,
    "curve": null,
    "sensitivityMa": null,
    "rcdType": null,
    "breakingKa": null,
    "modules": 6,
    "description": "Connected controller voor Niko Home Control II, 230 Vac, busvoeding 26 Vdc 400 mA, 6 modules",
    "sourceUrl": "https://cdn.niko.eu/550-00003/nl-NL/main_datasheet.pdf"
  }
]
